import React from 'react';
import './Mobese.scss';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

/* Original Mobese Page Content
import React, { useState } from 'react';
import './Mobese.scss';
import MobeseModal from './MobeseModal';

const Mobese = () => {
  const [selectedCamera, setSelectedCamera] = useState(null);

  // Örnek mobese kameraları - Gerçek verilerle değiştirilmeli
  const mobeseCameras = [
    {
      id: 1,
      name: 'İskenderun Merkez',
      location: 'Atatürk Bulvarı',
      streamUrl: 'STREAM_URL_1',
      thumbnail: '/assets/images/example-post1.webp'
    },
    {
      id: 2,
      name: 'Sahil Yolu',
      location: 'Sahil Caddesi',
      streamUrl: 'STREAM_URL_2',
      thumbnail: '/assets/images/example-post2.webp'
    },
    {
      id: 3,
      name: 'Şehir Meydanı',
      location: 'İskenderun Meydanı',
      streamUrl: 'STREAM_URL_3',
      thumbnail: '/assets/images/example-post3.webp'
    },
   
  ];

  const handleCameraClick = (camera) => {
    setSelectedCamera(camera);
  };

  const handleCloseModal = () => {
    setSelectedCamera(null);
  };

  return (
    <div className="mobese-page">
      <div className="mobese-header">
        <h1>Şehrimi İzliyorum</h1>
        <p>İskenderun'un çeşitli noktalarından canlı mobese görüntüleri</p>
      </div>

      <div className="mobese-grid">
        <div className="row">
          {mobeseCameras.map((camera) => (
            <div key={camera.id} className="col-md-6 col-lg-4 mb-4">
              <div 
                className="mobese-card" 
                onClick={() => handleCameraClick(camera)}
              >
                <div className="mobese-card-image">
                  <img src={camera.thumbnail} alt={camera.name} />
                  <div className="live-indicator">
                    <span className="pulse"></span>
                    CANLI
                  </div>
                </div>
                <div className="mobese-card-content">
                  <h3>{camera.name}</h3>
                  <p>{camera.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedCamera && (
        <MobeseModal
          camera={selectedCamera}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};
*/

const Mobese = () => {
  return (
    <div className="mobese-page">
      <div className="container py-5">
        <div className="row">
       
          <div className="col-md-12">
            <div className="coming-soon-container">
              <div className="coming-soon-content text-center">
                <img 
                  src="/assets/images/logo.png" 
                  alt="Çok Yakında" 
                  className="coming-soon-image"
                />
                <h2 className="mt-4">Şehrimi İzliyorum Çok Yakında Hizmetinizde</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mobese;
